require('./angular-resource');
module.exports = 'ngResource';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-resource/index.js
 ** module id = 899
 ** module chunks = 2
 **/